export var Name = 'bambuser-live-shopping';
export var BambuserLiveShopping = Name;
export var BambuserEventType;

(function (BambuserEventType) {
  BambuserEventType["ShowStarted"] = "show-started";
  BambuserEventType["ShowEnded"] = "show-ended";
  BambuserEventType["AddToBasket"] = "add-to-basket";
  BambuserEventType["ChatMessage"] = "chat-message";
  BambuserEventType["LikeButtonClicked"] = "like-button-clicked";
})(BambuserEventType || (BambuserEventType = {}));